// extracted by mini-css-extract-plugin
module.exports = {"grid":"e_B","leaderboard":"e_C"};